var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuth0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582 2313 c-9 -22 -168 -508 -196 -600 l-7 -23 339 0 339 0 16 43 c12 34 165 499 191 585 l7 22 -339 0 -340 0 -10 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 2328 c0 -6 42 -142 94 -302 52 -160 97 -301 101 -313 l6 -23 340 0 c196 0 339 4 339 9 0 10 -159 504 -189 586 l-18 50 -337 3 c-255 2 -336 -1 -336 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 1608 c-23 -98 -30 -257 -16 -346 17 -108 65 -246 118 -342 36 -63 75 -112 152 -190 l104 -105 48 145 c154 469 162 499 148 516 -11 14 -181 139 -263 194 -12 8 -56 40 -97 70 -41 31 -97 73 -126 93 l-51 37 -17 -72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2114 1631 c-34 -25 -96 -70 -137 -100 -42 -30 -73 -59 -70 -64 3 -6 1 -7 -5 -3 -7 4 -37 -12 -69 -36 -32 -24 -88 -65 -125 -91 -37 -26 -69 -51 -72 -56 -5 -8 22 -96 156 -508 24 -73 46 -133 50 -133 3 0 29 18 58 41 115 91 243 293 291 459 31 108 38 329 14 436 -9 44 -20 84 -24 90 -4 7 -28 -5 -67 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208 975 c-31 -23 -54 -46 -50 -50 4 -4 2 -5 -4 -3 -17 5 -135 -82 -128 -94 4 -6 2 -8 -4 -4 -8 5 -292 -187 -292 -199 0 -14 441 -325 452 -319 6 4 8 3 5 -3 -4 -6 14 -25 39 -43 51 -36 55 -35 125 18 20 15 89 65 153 110 67 48 113 88 110 94 -4 7 -2 8 4 4 11 -6 123 68 130 86 2 4 9 8 15 8 7 1 24 11 39 23 l26 22 -154 110 c-85 61 -173 125 -197 142 -110 85 -193 143 -202 142 -5 0 -36 -20 -67 -44z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth0);
export default __webpack_public_path__ + "static/media/auth0.f4bbafee.svg";
export { ForwardRef as ReactComponent };